import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('fk-loading-glass')
class FKLoadingGlass extends LitElement {

  override render() {
    return html``;
  }

  static styles = [css`
    :host {
      z-index: 9999;
      position: absolute;
      inset: 0;
      --loading-color: rgb(33, 150, 243);
      background: linear-gradient(
        135deg,
        color-mix(in srgb, var(--loading-color) 30%, transparent) 0%,
        color-mix(in srgb, var(--loading-color) 15%, transparent) 12.5%,
        color-mix(in srgb, var(--loading-color) 30%, transparent) 25%,
        color-mix(in srgb, var(--loading-color) 15%, transparent) 37.5%,
        color-mix(in srgb, var(--loading-color) 30%, transparent) 50%,
        color-mix(in srgb, var(--loading-color) 15%, transparent) 62.5%,
        color-mix(in srgb, var(--loading-color) 30%, transparent) 75%,
        color-mix(in srgb, var(--loading-color) 15%, transparent) 87.5%,
        color-mix(in srgb, var(--loading-color) 30%, transparent) 100%
      );
      background-size: 200% 200%;
      background-position: 0% 0%;
      animation: shimmer 3s linear infinite, fadeIn 1000ms ease-in forwards;
      opacity: 0;
    }

    @keyframes shimmer {
      0% {
        background-position: 0% 0%;
      }
      100% {
        background-position: 100% 100%;
      }
    }

    @keyframes fadeIn {
      to {
        opacity: 1;
      }
    }
  `];
}
